module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainDiv"
  }, [_c('div', {
    staticClass: "backBtn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('inline-svg', {
    staticClass: "backs-svg",
    attrs: {
      "src": require('../../assets/svg/back.svg').default
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("registration.privacy.title")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100%",
      "font-size": "14px",
      "text-align": "var(--src-position)"
    }
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text1")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text2")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text3")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text4")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("registration.privacy.text5")))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text6")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("registration.privacy.text7")))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text8")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text9")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("registration.privacy.text10")))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('registration.privacy.text11'))
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text12")) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "backBtn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('inline-svg', {
    staticClass: "backs-svg",
    attrs: {
      "src": require('../../assets/svg/back.svg').default
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44d0cf4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Registration/Privacy.vue
// module id = 502
// module chunks = 19